/* ==========================================================================
   ProductCardHotels > Client
   ========================================================================== */

/* Import modules */
const tippy = module.require('tippy.js');
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const Image = require('@bluekiri/alexandria-contrib-components/components/image/client/js');
const config = require('./config');

/**
 * ProductCardHotels component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function ProductCardHotels(selector = '[data-component=ProductCardHotels]', configuration = {}) {
    if (elementExist(selector)) {
        /* Instance */
        const instance = {};

        /* Element */
        instance.element = document.querySelector(selector);

        /* Image */
        instance.image = Image(`${selector} [data-component="Image"][data-type="${config().type.image}"]`, {
            ...configuration.image
        });

        // /* tippy */
        tippy(`${selector} [data-type="icon"]`, {
            arrow: true,
            arrowType: 'sharp',
            duration: 0,
            placement: 'bottom',
            theme: 'translucent base-dark highlights'
        });

        const elements = document.querySelectorAll(`${selector}`);

        elements.forEach(item => {
            const elementNav = item.querySelector('[data-type="nav-tab"]');
            const elementContent = item.querySelectorAll('[data-type="content"]');

            elementNav.addEventListener('click', event => {
                const { target } = event;

                if (!target.classList.contains('isActive')) {
                    elementNav.querySelector('.isActive').classList.remove('isActive');
                    target.classList.add('isActive');
                    elementContent.forEach(elem => elem.classList.toggle('isActive'));
                }
            });
        });

        /* Returns */
        return instance;
    }
};
